
export function random(min, max) {
    return min + Math.round( Math.random() * (max - min) );
}

export function sanitiseNum(num, decimals) {

    if (undefined === decimals) {
        decimals = 8;
    }

    const str = '' + num;
    const decimalPointIndex = str.indexOf('.');

    var retVal;

    if (decimalPointIndex >= 0) {
        // Need to avoid 10.100000000000001
        const strInt = str.substr(0, decimalPointIndex);
        const strMantissa = str.substr(decimalPointIndex + 1, decimals);
        retVal =  Number(strInt + '.' + strMantissa);
    }
    else {
        retVal =  Number(num);
    }

    // console.log(`sanitiseNum(${num}, ${decimals}) returning ${retVal}`);

    return retVal;
}